module.exports = __webpack_public_path__ + "img/att.6e1b63ca.png";